export function dataInRequest(params = {}) {
  return {
    type: '@edicaoTrocaTanque/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@edicaoTrocaTanque/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@edicaoTrocaTanque/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@edicaoTrocaTanque/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@edicaoTrocaTanque/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@edicaoTrocaTanque/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@edicaoTrocaTanque/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@edicaoTrocaTanque/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@edicaoTrocaTanque/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@edicaoTrocaTanque/RECORD_FILTERING',
    payload: { params },
  };
}
